module.exports = __webpack_public_path__ + "img/na-caribbean-transec.df673e6b.png";